var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#760000",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9754 16.8659C30.375 17.8307 30.375 19.0538 30.375 21.5C30.375 23.9462 30.375 25.1693 29.9754 26.1341C29.4425 27.4205 28.4205 28.4425 27.1341 28.9754C26.1693 29.375 24.9462 29.375 22.5 29.375H19.875C17.4001 29.375 16.1627 29.375 15.3938 28.6062C14.625 27.8373 14.625 26.5999 14.625 24.125V21.5C14.625 19.0538 14.625 17.8307 15.0246 16.8659C15.5575 15.5795 16.5795 14.5575 17.8659 14.0246C18.8307 13.625 20.0538 13.625 22.5 13.625C24.9462 13.625 26.1693 13.625 27.1341 14.0246C28.4205 14.5575 29.4425 15.5795 29.9754 16.8659ZM22.5 17.8751C23.0523 17.8751 23.5 18.3228 23.5 18.8751V20.4997H25.125C25.6773 20.4997 26.125 20.9474 26.125 21.4997C26.125 22.052 25.6773 22.4997 25.125 22.4997H23.5V24.1251C23.5 24.6774 23.0523 25.1251 22.5 25.1251C21.9477 25.1251 21.5 24.6774 21.5 24.1251V22.4997H19.875C19.3227 22.4997 18.875 22.052 18.875 21.4997C18.875 20.9474 19.3227 20.4997 19.875 20.4997H21.5V18.8751C21.5 18.3228 21.9477 17.8751 22.5 17.8751Z",
    fill: "#760000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.98f228acb53ca54ea9cd36c62586d033.svg";
export { ForwardRef as ReactComponent };